<template>
    <div class="social__links">
        <ul class="links">
            <li class="link share-icon">
                <i class="icons8-share "></i>
            </li>
            <div class="vl"></div>
            <li class="link">
                <a href="#" target="_blank">
                    <i class="icons8-share-linkweb-01"></i>
                </a>
            </li>
            <li class="link">
                <a href="#" target="_blank">
                    <i class="icons-foo"></i>
                </a>
            </li>
            <li class="link">
                <a href="https://www.facebook.com/sharer/sharer.php?" target="_blank">
                    <i class="icons8-share-fb-01"></i>
                </a>
            </li>
            <li class="link">
                <a href="https://twitter.com/intent/tweet"
                   data-text="Join our international family of Bohemians"
                   :data-url="'https://careers.bohemia.net/position/' + slug"
                   target="_blank" data-size="large">
                    <i class="icons8-share-tw-01-01"></i>
                </a>
            </li>
            <li class="link">
                <a href="#">
                    <i class="icons8-share-in-01"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SocialIcons",
        props: {
            name: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
            slug: {
                type: String,
                default: ''
            }
        },

    }
</script>

<style scoped lang="scss">
    .social__links {
        position: relative;
        width: 50px;
        margin: 20px;
    }

    .toggle-input {
        position: relative;
        width: 50px;
        height: 50px;
    }

    .links {
        display: flex;
        margin: auto;
        width: 20%;
        align-items: center;
    }

    .link {
        text-align: center;
        display: inline-block;
        justify-content: center;
        align-self: center;
        font-size: 27px;
        margin-right: 4px;
        flex-wrap: nowrap;

        a {
            color: gray;
        }
    }

    .vl {
        border-left: 1px solid gray;
        height: 30px;
        margin-left: 7px;
        margin-right: 7px;
    }

    .share-text {
        font-size: 16px !important;
        line-height: 28px;
        color: gray;
        align-self: center;
    }

    .share-icon {
        font-size: 14px;
        color: gray;

    }


</style>


// WEBPACK FOOTER //
// src/components/common/SocialIcons.vue